export const GENERAL_addEditDelete = async (
  action: 'add' | 'edit' | 'delete',
  url: string,
  data: any
): Promise<
  | {
      success: any;
      error: null;
    }
  | {
      success: null;
      error: {
        data: any;
      };
    }
> => {
  let response = null;
  if (action === 'add') {
    response = await apiPostRequest(url, data);
  } else if (action === 'edit') {
    response = await apiPutRequest(`${url}${data.id}/`, data);
  } else if (action === 'delete') {
    response = await apiDeleteRequest(`${url}${data.id}/`);
  }

  return response as any;
};

export const backendGetRequest = async (
  url: string,
  {
    page = 1,
    page_size = 10,
    sortBy = [] as { key: string; order: 'asc' | 'desc' }[],
  },
  filters: any = {},
  search: string = ''
) => {
  const finalUrl = buildQuery(
    url,
    { page, page_size: page_size, sort: sortBy },
    filters,
    search
  );

  const response = await $fetch(finalUrl, {
    method: 'GET',
    headers: getHeaders(),
  });

  return response;
};

// Function to generate authorization headers
export function getHeaders() {
  const authCookie = useCookie<{ access: string; refresh: string }>('jwtToken');
  return {
    Authorization: `Bearer ${authCookie.value ? authCookie.value.access : ''}`,
  };
}

// Utility function to build the query string with pagination and filters
const buildQuery = (
  url: string,
  {
    page,
    page_size,
    sort,
  }: {
    page: number;
    page_size: number;
    sort: { key: string; order: 'asc' | 'desc' }[];
  },
  filters: any,
  search: string
) => {
  const query = new URLSearchParams();
  query.set('page', page.toString());
  query.set('page_size', page_size.toString());

  if (sort.length) {
    // Reminder: Django is used as the backend for this project
    query.set(
      'ordering',
      sort.map((s) => `${s.order === 'desc' ? '-' : ''}${s.key}`).join(',')
    );
  }

  if (search) {
    query.set('search', search);
  }

  for (const key in filters) {
    query.set(key, filters[key]);
  }

  return `${url}?${query.toString()}`;
};
